import mustache from 'mustache';

/* Responsibility: Enforce compiling of mustache templates */

/* When we compile templates first, then the string parsing is only done once,
 * instead of once per item to be rendered.
 *
 * Here we only expose the compiling, to help nudge developers to use
 * the best way.
 */
export default mustache.compile;
